import { Stack, Box, CircularProgress, FormControl, InputLabel, MenuItem, OutlinedInput, Select, Table, TablePagination, TableSortLabel, styled, useMediaQuery, Grid } from '@mui/material'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import ActionsBar from '../../../components/ActionsBar';
import { FilterAlt } from '@mui/icons-material'
import TextField from '@mui/material/TextField/TextField';
import MemberItem from './components/MemberItem';
import Paper from '@mui/material/Paper'
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses, } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useAtom, useAtomValue } from 'jotai';
import { authAtom, customersAtom, staffsAtom, tokenAtom } from '../../../actions';
import axios from 'axios';
import { visuallyHidden } from '@mui/utils'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { hasPermission } from '../../../utils/utils';

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        color: theme.palette.common.white,
    },
}));

const headCells = [
    {
        id: 'full_name',
        paddingRight: false,
        disablePadding: false,
        label: 'Họ tên',
    },
    {
        id: 'username',
        paddingRight: true,
        disablePadding: false,
        label: 'Số điện thoại',
    },
    {
        id: 'totalOrder',
        paddingRight: true,
        disablePadding: false,
        label: 'Số liệu trình đã mua',
    },
    {
        id: 'totalPrice',
        paddingRight: true,
        disablePadding: false,
        label: 'Tổng chi',
    },
    {
        id: 'staffs',
        paddingRight: true,
        disablePadding: false,
        label: 'Nhân sự hỗ trợ',
    },
];

function EnhancedTableHead(props) {
    const { order, orderBy, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <StyledTableCell
                        key={headCell.id}
                        align={headCell.paddingRight ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                            sx={
                                {
                                    '&.MuiTableSortLabel-root': {
                                        color: 'white',
                                    },
                                    '&.MuiTableSortLabel-root:hover': {
                                        color: 'white',
                                    },
                                    '&.Mui-active': {
                                        color: 'white',
                                    },
                                    '& .MuiTableSortLabel-icon': {
                                        color: 'white !important',
                                    },
                                }
                            }
                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </StyledTableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}



const Screen = () => {
    const isMobile = useMediaQuery('(max-width:600px)');
    const [customers, setCustomers] = useAtom(customersAtom);
    const [token] = useAtom(tokenAtom);
    const [loading, setLoading] = useState(false);
    const [keyword, setKeyword] = useState('');
    const [staffs] = useAtom(staffsAtom);
    const [total, setTotal] = useState(0);
    const searchTimeout = useRef(null);
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('totalOrder');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(50);
    const [selectedStaff, setSelectedStaff] = useState(0);
    const { id: source_id } = useParams();
    const authUser = useAtomValue(authAtom);
    const timeoutRef = useRef(null);
    const [debouncedKeyword, setDebouncedKeyword] = useState('');

    useEffect(() => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(() => {
            setDebouncedKeyword(keyword);
        }, 500);

        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [keyword]);

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
        setPage(0);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChangeKeyword = (event) => {
        setKeyword(event.target.value);
        setPage(0);
    };

    const getCustomers = useCallback(() => {
        if (token) {
            setLoading(true);
            try {
                if (searchTimeout.current) {
                    clearTimeout(searchTimeout.current);
                    searchTimeout.current = null;
                }
            } catch (error) {
                console.log({ error });
            }

            searchTimeout.current = setTimeout(() => {
                axios.post('/accounts/customers/customer_list/', {
                    keyword: debouncedKeyword.replace(/#/g, ''),
                    order,
                    orderBy,
                    offset: page * rowsPerPage,
                    limit: rowsPerPage,
                    staff: selectedStaff > 0 ? selectedStaff : null,
                    source: source_id,
                    leadSearch: true,
                })
                    .then((response) => {
                        if (response && response.data) {
                            setCustomers(response.data.customers ?? []);
                            setTotal(response.data.total ?? 0);
                        }
                        setLoading(false);
                    })
                    .catch((error) => {
                        console.log({ error });
                        setLoading(false);
                    });
            }, 500);
        }
    }, [token, debouncedKeyword, setCustomers, order, orderBy, page, rowsPerPage, selectedStaff, source_id]);

    useEffect(() => {
        getCustomers();
    }, [getCustomers, token]);

    const staffOptions = staffs.map((staff) => ({ label: staff.full_name, id: staff.id }));
    staffOptions.unshift({ label: 'Tất cả', id: 0 });

    if (!(authUser && hasPermission(authUser, ['view_group', 'view_group_all']))) {
        return (
            <Stack sx={{ flex: 1, alignItems: 'center', justifyContent: 'center', margin: '32px' }}>
                Không có quyền truy cập
            </Stack>
        );
    }

    return (
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', width: '100%' }}>
            <ActionsBar title="Danh sách khách hàng" subTitle={`Tìm thấy ${total} khách hàng`} />
            <Grid container spacing={2} sx={{zIndex: 5}}>
                <Grid item xs={6} md={6}>
                    <TextField
                        style={{ width: '100%', height: '36px', fontSize: '12px', color: 'black' }}
                        size="small"
                        value={keyword}
                        onChange={handleChangeKeyword}
                        label="Tìm kiếm tên, sđt"
                    />
                </Grid>
                <Grid item xs={6} md={6}>
                    {hasPermission(authUser, ['view_group_all']) && (
                        <FormControl sx={{ width: '100%' }} variant="standard">
                            <InputLabel sx={{ fontSize: '12px' }}>Nhân viên</InputLabel>
                            <Select
                                sx={{ fontSize: '12px' }}
                                value={selectedStaff}
                                onChange={(e) => setSelectedStaff(e.target.value)}
                                label="Nhân viên"
                            >
                                {staffOptions.map((item) => (
                                    <MenuItem key={item.id} value={item.id}>
                                        {item.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                </Grid>
            </Grid>

            {loading && <Stack sx={{ width: '100%', alignItems: 'center' }}><CircularProgress /></Stack>}
            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '24px', }}>
                <Paper style={{ padding: '16px' }}>
                    <TablePagination
                        rowsPerPageOptions={[20, 30, 40, 50]}
                        component="div"
                        count={total}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                    <TableContainer
                        component={Paper}
                        style={{
                            overflowY: 'scroll',
                            width: '100%',
                            maxHeight: isMobile ? '60vh' : '60vh',
                        }}
                    >
                        <Table sx={{ minWidth: 650 }} aria-label="data table" stickyHeader>
                            <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} rowCount={total} />
                            <TableBody>
                                {customers.map((customer) => (
                                    <MemberItem key={customer.id} customer={customer} />
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Paper>
            </div>
        </div>
    );
};

export default Screen;